<template>
    <Background
        :backPath="'/home'">

        <ListView
            v-if="searching"
            ref="searchList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :clickCallback="clickStaffer"
            :listWidth="50"
        />
        <div
            v-else
            class="content-area">
            <ListView
                v-if="role == 1"
                ref="userList"
                :titles="titles"
                :columnWidths="columnWidths"
                :columnCells="columnCells"
                :fetchCallback="fetchUserList"
                :clickCallback="clickStaffer"
                :addCallback="addStaffer"
                :listWidth="50"
            />
            <div
                v-else
                class="note">
                只有超级管理员才有权限访问此页面
            </div>
        </div>

        <AddStafferDialog ref="dialog"/>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import AddStafferDialog from "./AddStafferDialog.vue"

 import InputSearch from "ant-design-vue/lib/input/Search";

 import { isEmptyOrWhitespace } from "../util/utils.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'StafferManage',
     data() {
         return {
             role: -1,
             amount: 0,
             searchContent: "",
             searchNumber: 0,
             searching: false,
             titles: ["账号ID", "姓名", "登录账号", "账户类型"],
             columnWidths: [10, 30, 40, 20],
             columnCells: [
                 { value: "UserId",
                   style: ""
                 },
                 { value: "DisplayName",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "Username",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "RoleName",
                   style: "text-align: end; padding-right: 20px;"
                 },
             ]
         }
     },
     components: {
         Background,
         ListView,
         AddStafferDialog
     },
     computed: {
     },
     mounted() {
         this.role = localStorage.getItem("role")
     },
     methods: {
         clickStaffer(item) {
             sessionStorage.setItem("clickStafferInfo", JSON.stringify(item))

             this.$router.push("/stafferInfo")
         },
         addStaffer() {
             this.$refs.dialog.show()
         },
         fetchUserList(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/user?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 for (var i = 0; i < response.length; i++) {
                     if (response[i].Role == 1) {
                         response[i].RoleName = "超级管理员"
                     } else if (response[i].Role == 10) {
                         response[i].RoleName = "后台人员"
                     }
                 }

                 callback(response)
             })
         },
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #999;
 }

 .note {
     font-size: 30px;
     color: #666;
 }

 .content-area {
     width: 100%;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
 }
</style>
